import PackAssignDropdown from "./PackAssignDropdown";
import { getMatrixPoolScopeOptions, writeMatrixPoolScope } from "../utils/gameWordPool";

export default function MatrixPoolScopeDropdown({ level, value, onChange }) {
  const options = getMatrixPoolScopeOptions(level);

  const handleChange = (nextValue) => {
    writeMatrixPoolScope(nextValue);
    onChange(nextValue);
  };

  return (
    <div className="mastery-matrix__scope-dropdown">
      <PackAssignDropdown
        options={options}
        value={value}
        onChange={handleChange}
        ariaLabel="Portée du pool affiché dans la matrice"
      />
    </div>
  );
}
